import { ArrowRight, FileText, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="py-16 md:py-24 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold">
            Готов стать частью чемпионата?
          </h2>
          <p className="mt-6 text-xl text-gray-300">
            Присоединяйся к сотням участников, которые уже начали свой путь в креативных индустриях.
          </p>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-800 rounded-2xl p-8 hover:bg-gray-700 transition-colors">
              <div className="inline-flex p-4 bg-primary-500/20 rounded-full">
                <FileText className="h-8 w-8 text-primary-400" />
              </div>
              <h3 className="text-2xl font-bold mt-6">Прочти Положение</h3>
              <p className="mt-3 text-gray-300">
                Ознакомься с правилами, критериями оценки и требованиями к участникам.
              </p>
              <a
                href="/documents/regulation/polozhenie_2026-2027.pdf"
                className="inline-flex items-center mt-6 text-primary-400 font-semibold hover:text-primary-300"
              >
                Скачать PDF
                <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </div>

            <div className="bg-gray-800 rounded-2xl p-8 hover:bg-gray-700 transition-colors">
              <div className="inline-flex p-4 bg-accent-500/20 rounded-full">
                <MessageCircle className="h-8 w-8 text-accent-400" />
              </div>
              <h3 className="text-2xl font-bold mt-6">Задай вопрос</h3>
              <p className="mt-3 text-gray-300">
                Уточни детали в MAX-чате поддержки. Наши менторы ответят в течение дня.
              </p>
              <a
                href="https://max.ru/join/jgM0K2Z4bv69V0W2y-mFAHJa5CfTIOlmkiyvsCvNgRY"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center mt-6 text-accent-400 font-semibold hover:text-accent-300"
              >
                Перейти в чат
                <ArrowRight className="ml-2 h-4 w-4" />
              </a>
            </div>

            <div className="bg-gray-800 rounded-2xl p-8 hover:bg-gray-700 transition-colors border-2 border-primary-500">
              <div className="inline-flex p-4 bg-primary-500/30 rounded-full">
                <ArrowRight className="h-8 w-8 text-primary-300" />
              </div>
              <h3 className="text-2xl font-bold mt-6">Подай заявку</h3>
              <p className="mt-3 text-gray-300">
                Зарегистрируйся и прикрепи портфолио (если есть). Это займёт не более 10 минут.
              </p>
              <Link
                to="/registration"
                className="inline-flex items-center justify-center mt-6 w-full py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-colors"
              >
                Начать регистрацию
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </div>
          </div>

          <div className="mt-16 pt-8 border-t border-gray-800">
            <p className="text-gray-400">
              Остались сомнения?{' '}
              <Link to="/faq" className="text-primary-400 font-semibold hover:underline">
                Посмотри ответы на частые вопросы
              </Link>{' '}
              или{' '}
              <Link to="/contacts" className="text-primary-400 font-semibold hover:underline">
                свяжись с организаторами
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}